export interface IDelaySetting {
    id: number | string;
    delay?: number;
}

export interface IDelayOption {
    value: number | string;
    label: string;
}

export function getDelayLabel(delay: number | undefined, options: IDelayOption[]): string {
    if (!delay) {
        return '';
    }

    const option = options.find(row => row.value === delay);

    return (option ? option.label : '').replace(/^Задержка\s*/i, '').trim();
}

export function findDelaySetting(settings: IDelaySetting[], channelId: number): IDelaySetting | undefined {
    return settings.find(row => parseInt(String(row.id)) === channelId);
}
